module.exports = __webpack_public_path__ + "img/infobanner.f260ac22.png";